import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { Store } from 'antd/lib/form/interface';
import { Layout, Typography, Input, Table, Select, Pagination, Alert } from 'antd';
import { CriteriaForm, AuthButton, AuthButtonAuthorities, Checkbox } from '../../core/CoreForm';
import { Header, ContentEx as Content, FooterButtonArea, Footer, FunctionTitle, CommonMessage } from '../../core/CorePageContents';
import styles from './QualificationHoldersList.module.css';
import * as Module from '../../../modules/prime/qualifications-holders/qualificationHoldersModule';
import * as Model from '../../../modules/prime/qualifications-holders/qualificationHoldersModel';
import { initMessages, setMessages, message } from '../../../modules/core/commonMessageModule';
import * as CONSTANTS from '../../../constants/constants';
import * as formatUtils from '../../../utils/formatUtils';
import * as constantsUtils from '../../../utils/constantsUtils';
import * as messagesUtils from '../../../utils/messagesUtils';
import * as Utils from '../../../utils/utils';
import { SortOrder } from 'antd/lib/table/interface';
import AuthButtonStyles from "../../core/css/AuthButton.module.css";
import { initApiResult, storedApiResult } from '../../../modules/core/bffApiModule';
import { storedLoginUserInfo } from '../../../modules/core/authModule'
import { CcusLevelLabel } from '../../core/parts/CcusLevelLabel';

interface titleInterface {
  title: string;
}

export const QualificationHoldersList = (props: titleInterface) => {
  //　hoocs
  const dispatch = useDispatch();
  const history = useHistory();
  // ステート取得
  const apiResult = useSelector(storedApiResult);
  const loginUserInfo = useSelector(storedLoginUserInfo);
  let dataList = useSelector(Module.storedDataList);
  let dataCriteria = useSelector(Module.storedCriteria);
  let managementGroupList = useSelector(Module.storedManagementGroupList);
  const belongCompanyData = useSelector(Module.storedBelongCompanyDataRow);
  const totalCnt = useSelector(Module.storedTotal);

  useEffect(() => {
    if (dataCriteria.belongCompanyId === "") {
      // 共通メッセージ情報を初期化します。
      dispatch(initMessages());
      history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_HOLDERS_COMPANIES);
      return;
    }

    // API結果情報を初期化します。
    dispatch(initApiResult());
    dispatch(Module.getQualificationHolderDataListAsync(dataCriteria));
  },
    [dataCriteria]
  );

  /**
   * 画面アクション
   * 
   */
  //　行選択時アクション
  const moveToDetail = (record: Model.QualificationHolderDataRow) => {
    // 作業員IDを設定します。
    dispatch(Module.prepareMoveToDetail(record.workerId));
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    // 詳細画面へ遷移します。
    history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_HOLDERS_DETAIL);
  }

  //　戻るボタン押下時アクション
  const backClicked = () => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_HOLDERS_COMPANIES);
  }

  //　登録ボタン押下時アクション
  const addClicked = () => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    // 独自資格一覧行定義のstateを初期化します。
    dispatch(Module.initDataRow());
    // 登録画面へ遷移します。
    history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_HOLDERS_ADD);
  }

  // 検索ボタン押下時イベント
  const searchDataList = (value: Store) => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    criteriaDataTransfer([
      { key: "managementGroupId", value: value.managementGroupId }
      , { key: "originalQualificationName", value: value.originalQualificationName }
      , { key: "workerId", value: value.workerId }
      , { key: "firstName", value: value.firstName }
      , { key: "lastName", value: value.lastName }
      , { key: "firstNameKana", value: value.firstNameKana }
      , { key: "lastNameKana", value: value.lastNameKana }
      , { key: "ccusCraftsmanId", value: value.ccusCraftsmanId }
      , { key: "ccusLevel", value: Number(value.ccusLevel) } // 数値に変換
      , { key: "primeCertificationNo", value: value.primeCertificationNo }
      , { key: "offset", value: 0 }
      , { key: "onlyEnableQualification", value: value.onlyEnableQualification === true ? "1" : "0" }
      , { key: "excludeRetiredWorker", value: value.excludeRetiredWorker === true ? "1" : "0" }
    ]);
  }

  /**
   * テーブル検索条件変更時イベント（ソート）
   * @param sort
   */
  const handleTableChange = (sort: any) => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let order = "";
    if (sort.order === "ascend") {
      order = "0";
    } else if (sort.order === "descend") {
      order = "1";
    }
    let sortItem = sort.columnKey
    if (typeof sort.column === "undefined") {
      sortItem = "";
    }

    criteriaDataTransfer([
      { key: "sortItem", value: sortItem }
      , { key: "sortOrder", value: order }
      , { key: "limit", value: dataCriteria.limit }
      , { key: "offset", value: 0 } // ソート切替時は1ページ目から表示
    ])
  }

  /**
   * ページ変更時イベント（ページ、表示件数）
   * @param pagination
   * @param filters
   */
  const handlePaginationChange = (page: any, pageSize: any) => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let offsetReset: boolean = false;
    if (dataCriteria.limit !== pageSize) {
      offsetReset = true;
    }

    criteriaDataTransfer([
      { key: "sortItem", value: dataCriteria.sortItem }
      , { key: "sortOrder", value: dataCriteria.sortOrder }
      , { key: "limit", value: pageSize }
      , { key: "offset", value: offsetReset ? 0 : (page - 1) * pageSize }
    ])
  }

  // CriteriaをStoreに保持
  const criteriaDataTransfer = (keyValueList: Array<{ key: string, value: any }>) => {
    let criteria: Model.QualificationHolderCriteria = {
      belongCompanyId: dataCriteria.belongCompanyId,
      managementGroupId: dataCriteria.managementGroupId,
      originalQualificationName: dataCriteria.originalQualificationName,
      workerId: dataCriteria.workerId,
      firstName: dataCriteria.firstName,
      lastName: dataCriteria.lastName,
      firstNameKana: dataCriteria.firstNameKana,
      lastNameKana: dataCriteria.lastNameKana,
      ccusCraftsmanId: dataCriteria.ccusCraftsmanId,
      ccusLevel: dataCriteria.ccusLevel,
      primeCertificationNo: dataCriteria.primeCertificationNo,
      sortItem: dataCriteria.sortItem,
      sortOrder: dataCriteria.sortOrder,
      offset: dataCriteria.offset,
      limit: dataCriteria.limit,
      onlyEnableQualification: dataCriteria.onlyEnableQualification,
      excludeRetiredWorker: dataCriteria.excludeRetiredWorker
    }
    keyValueList.forEach((rec: { key: string, value: any }) => {
      criteria[rec.key] = rec.value;
    })
    dispatch(Module.setQualificationHolderCriteria(criteria));
  }

  // 検索が正常終了した時の処理
  if (CONSTANTS.API_STATUS_INITIAL !== apiResult.status
    && "" === apiResult.errorCode
    && CONSTANTS.REQUEST_METHOD_GET === apiResult.requestMethod
    && CONSTANTS.URL_QUALIFICATIONS_HOLDERS_PRIME_LIST === apiResult.url) {

    // 2ページ目以降を表示していて、総件数はあるが、表示するデータが空の場合、再取得する
    if (dataCriteria.offset > 0 && totalCnt > 0 && dataList.length === 0) {

      // API結果情報を初期化します。
      dispatch(initApiResult());

      // 最終ページを取得する（基本的には一つ前のページ）
      const newOffset = Utils.calcLastPageOffset(totalCnt, dataCriteria.limit);
      criteriaDataTransfer([
        { key: "offset", value: newOffset }
      ]);
    }
  }

  /**
   * 描画用メソッド
   * 
   */

  // 数値型にフォーマットします。 
  const renderFormattedNumber = (value: number, row: Model.QualificationHolderDataRow) => {
    const formattedValue = formatUtils.formatNumberComma(value);
    return {
      children: (
        <div className={styles.columnAlignRight}>{formattedValue}</div>
      )
    }
  }

  // 登録ボタン表示権限有無を判定します。
  const isDisplayOperationButton = () => {
    if (loginUserInfo.authorityInfo.primeSystemMngAuth === "0") {
      // 管理者権限を持っていない場合、非表示
      return false;
    }
    return true;
  }

  // 検索条件エリアを描画します。
  const QualificationCriteria = () => {
    return (
      <CriteriaForm
        layout="inline"
        onFinish={searchDataList}
        // 初期値はFormに設定する
        initialValues={{
          'managementGroupId': dataCriteria.managementGroupId
          , 'primeCertificationNo': dataCriteria.primeCertificationNo
          , 'lastName': dataCriteria.lastName
          , 'firstName': dataCriteria.firstName
          , 'lastNameKana': dataCriteria.lastNameKana
          , 'firstNameKana': dataCriteria.firstNameKana
          , 'ccusCraftsmanId': dataCriteria.ccusCraftsmanId
          , 'ccusLevel': dataCriteria.ccusLevel.toString() // 文字列に変換
          , 'originalQualificationName': dataCriteria.originalQualificationName
          , 'onlyEnableQualification': dataCriteria.onlyEnableQualification === "1" ? true : false
          , 'excludeRetiredWorker': dataCriteria.excludeRetiredWorker === "1" ? true : false
        }}
      >
        <div className={styles.criteriaSearchField}>
          <div className={styles.criteriaSearchFieldLeftBox}>
            <CriteriaForm.Item name="managementGroupId" id="managementGroupId" label={"独自資格認定支店"}>
              <Select className={styles.formSelect}>
                <Select.Option value={""}>（全て）</Select.Option>
                {managementGroupList.map((rec: Model.managementGroupRow) => (
                  <Select.Option key={rec.managementGroupId} value={rec.managementGroupId}>{rec.managementGroupName}</Select.Option>
                ))}
              </Select>
            </CriteriaForm.Item>
            <CriteriaForm.Item name="primeCertificationNo" id="primeCertificationNo">
              <Input
                type="text"
                placeholder="元請認定番号"
                maxLength={CONSTANTS.PRIME_CERTIFICATION_NO_MAX_LENGTH}
              />
            </CriteriaForm.Item>
            <CriteriaForm.Item name="lastName">
              <Input
                type="text"
                placeholder="氏名（姓）"
                maxLength={CONSTANTS.LAST_NAME_MAX_LENGTH}
              />
            </CriteriaForm.Item>
            <CriteriaForm.Item name="firstName">
              <Input
                type="text"
                placeholder="氏名（名）"
                maxLength={CONSTANTS.FIRST_NAME_MAX_LENGTH}
              />
            </CriteriaForm.Item>
            <CriteriaForm.Item name="lastNameKana">
              <Input
                type="text"
                placeholder="氏名カナ（姓）"
                maxLength={CONSTANTS.LAST_NAME_KANA_MAX_LENGTH}
              />
            </CriteriaForm.Item>
            <CriteriaForm.Item name="firstNameKana">
              <Input
                type="text"
                placeholder="氏名カナ（名）"
                maxLength={CONSTANTS.FIRST_NAME_KANA_MAX_LENGTH}
              />
            </CriteriaForm.Item>
            <CriteriaForm.Item name="ccusCraftsmanId">
              <Input
                type="text"
                placeholder="CCUS技能者ID"
                maxLength={CONSTANTS.CCUS_CRAFTSMAN_ID_MAX_LENGTH}
              />
            </CriteriaForm.Item>
            <CriteriaForm.Item name="ccusLevel" id="ccusLevel" label={"技能レベル"}>
              <Select className={styles.formSelect}>
                <Select.Option value={"0"}>（指定なし）</Select.Option>
                {constantsUtils.getCodeLabelListOf(CONSTANTS.CCUS_LEVEL).map((codelabel) => (
                  <Select.Option key={codelabel.code} value={codelabel.code}>{codelabel.label}</Select.Option>
                ))}
              </Select>
            </CriteriaForm.Item>
            <CriteriaForm.Item name="originalQualificationName">
              <Input
                type="text"
                placeholder="独自資格名"
                maxLength={CONSTANTS.QUALIFICATION_NAME_MAX_LENGTH}
              />
            </CriteriaForm.Item>
          </div>
          <CriteriaForm.Item name="onlyEnableQualification" valuePropName="checked">
            <Checkbox>
              有効資格のみ
            </Checkbox>
          </CriteriaForm.Item>
          <CriteriaForm.Item name="excludeRetiredWorker" valuePropName="checked">
            <Checkbox>
              退職済作業員を除く
            </Checkbox>
          </CriteriaForm.Item>
          <AuthButton
            name={"検索"}
            htmlType="submit"
            shape="round"
          />
        </div>
      </CriteriaForm>
    )
  }

  // 技能レベルを描画します。
  const CcusLevel = (row: Model.QualificationHolderDataRow) => {
    return <CcusLevelLabel ccusLevel={row.ccusLevel} ccusErrorFlag={row.ccusErrorFlag} />
  };

  // テーブル列を設定します。
  const columns = [
    {
      title: '独自資格認定支店'
      , dataIndex: 'managementGroupName'
      , key: '1'
      , width: 120
      , sortOrder: dataCriteria.sortItem !== '1' ? null : dataCriteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder
      , sorter: true
      , showSorterTooltip: false
      , align: 'center' as 'center'
      , render: (value: string, row: Model.QualificationHolderDataRow) => {
        return {
          children: (
            <div className={styles.columnAlignLeft}>{row.managementGroupName}</div>
          )
        }
      }
    },
    {
      title: '元請認定番号'
      , dataIndex: 'primeCertificationNo'
      , key: '2'
      , width: 300
      , sorter: true
      , sortOrder: dataCriteria.sortItem !== '2' ? null : dataCriteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder
      , showSorterTooltip: false
      , align: 'center' as 'center'
    },
    {
      title: '氏名'
      , dataIndex: 'name'
      , key: '3'
      , width: 100
      , sorter: true
      , sortOrder: dataCriteria.sortItem !== '3' ? null : dataCriteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder
      , showSorterTooltip: false
      , align: 'center' as 'center'
      , render: (value: string, row: Model.QualificationHolderDataRow) => {
        return {
          children: (
            <div className={styles.columnAlignLeft}>{row.lastName + ' ' + row.firstName}</div>
          )
        }
      }
    },
    {
      title: '生年月日'
      , dataIndex: 'birthday'
      , key: '4'
      , width: 100
      , sorter: true
      , sortOrder: dataCriteria.sortItem !== '4' ? null : dataCriteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder
      , showSorterTooltip: false
      , align: 'center' as 'center'
      , render: (value: string, row: Model.QualificationHolderDataRow) => {
        return {
          children: (
            formatUtils.formatDateSlash(row.birthday)
          )
        }
      }
    },
    {
      title: '在職中/退職済'
      , dataIndex: 'retiredFlag'
      , key: '9'
      , width: 80
      , sorter: true
      , sortOrder: dataCriteria.sortItem !== '9' ? null : dataCriteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder
      , showSorterTooltip: false
      , align: 'center' as 'center'
      , render: (value: string, row: Model.QualificationHolderDataRow) => {
        return {
          children: (
            <div>{row.retiredFlag === CONSTANTS.RETIRED_FLAG.RETIRED ? "退職済" : "在職中"}</div>
          )
        }
      }
    },
    {
      title: 'CCUS技能者ID'
      , dataIndex: 'ccusCraftsmanId'
      , key: '10'
      , width: 120
      , sorter: true
      , sortOrder: dataCriteria.sortItem !== '10' ? null : dataCriteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder
      , showSorterTooltip: false
      , align: 'center' as 'center'
      , render: (value: string, row: Model.QualificationHolderDataRow) => {
        return {
          children: (
            <>
              {Utils.isNullOrEmpty(row.ccusCraftsmanId) ? "－" : row.ccusCraftsmanId}
            </>
          )
        }
      }
    },
    {
      title: '技能レベル'
      , dataIndex: 'ccusLevel'
      , key: '11'
      , width: 150
      , sorter: true
      , sortOrder: dataCriteria.sortItem !== '11' ? null : dataCriteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder
      , showSorterTooltip: false
      , align: 'center' as 'center'
      , render: (value: string, row: Model.QualificationHolderDataRow) => {
        return {
          children: (
            <>
              {CcusLevel(row)}
            </>
          )
        }
      }
    },
    {
      title: <span>CCUSデータ<br />初回取得日</span>
      , dataIndex: 'ccusFetchedDatetime'
      , key: '12'
      , width: 90
      , sorter: true
      , sortOrder: dataCriteria.sortItem !== '12' ? null : dataCriteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder
      , showSorterTooltip: false
      , align: 'center' as 'center'
      , render: (value: string, row: Model.QualificationHolderDataRow) => {
        return {
          children: (
            <>
              {Utils.isNullOrEmpty(row.ccusFetchedDatetime) ? "－" : formatUtils.formatDateSlash(row.ccusFetchedDatetime)}
            </>
          )
        }
      }
    },
    {
      title: '有効独自資格数'
      , dataIndex: 'numberOfQualifications'
      , key: '5'
      , width: 120
      , render: renderFormattedNumber
      , sorter: true
      , sortOrder: dataCriteria.sortItem !== '5' ? null : dataCriteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder
      , showSorterTooltip: false
      , align: 'center' as 'center'
    }
  ];

  // テーブルエリアを描画します。
  const QualificationTable = () => {
    if (totalCnt > 0 && dataList.length > 0) {
      return (
      <>
        <div className={"topPagination"}>
          <Pagination
            className={"commonPagination topLeftPagination"}
            defaultPageSize={10}
            pageSize={dataCriteria.limit}
            pageSizeOptions={["5", "10", "20", "50", "100"]}
            showSizeChanger={true}
            showTotal={() => (<span>１ページあたりの表示件数</span>)}
            locale={{ items_per_page: "件/ページ" }}
            onChange={handlePaginationChange}
            onShowSizeChange={(page, size) => {
              handlePaginationChange(page, size); // ページサイズ変更時に1ページ目へ戻す
            }}
          />
          <Pagination
            className={"commonPagination topRightPagination"}
            total={totalCnt}
            current={dataCriteria.offset / dataCriteria.limit + 1}
            pageSize={dataCriteria.limit}
            showTotal={(total) => <><span>{total.toLocaleString()}</span> 件数中、<span>{(dataCriteria.offset + 1).toLocaleString()}</span> － <span>{total <= dataCriteria.offset + dataCriteria.limit ? total.toLocaleString() : (dataCriteria.offset + dataCriteria.limit).toLocaleString()}</span> 件</>}
            onChange={handlePaginationChange}
          />
        </div>
        <Table
          columns={columns}
          sortDirections={['ascend', 'descend']}
          size='small'
          dataSource={dataList}
          sticky={{ offsetHeader : -31 }}
          pagination={false}
          onChange={(pagination, filters, sorter) => handleTableChange(sorter)}
          onRow={(record, rowIndex) => {
            return {
              onClick: event => { moveToDetail(record) }
            };
          }}
        />
        <Pagination
          className={"commonPagination bottomPagination"}
          total={totalCnt}
          current={dataCriteria.offset / dataCriteria.limit + 1}
          pageSize={dataCriteria.limit}
          onChange={handlePaginationChange}
        />
      </>
      )
    }
    return (
      <></>
    )
  }

  // 所属会社を描画します。
  const BelongCompany = () => {
    return (
      <div className={styles.belongCompany}>
        <span>{"所属会社：" + belongCompanyData.belongCompanyName}</span>
      </div>
    )
  }

  // フッターボタンエリアを描画します。
  const ButtonArea = () => {
    return (
      <FooterButtonArea>
        <AuthButton
          name={"戻る"}
          className={AuthButtonStyles.backButtonFixed}
          size={"large"}
          shape={"round"}
          onClick={backClicked}
        />
        {isDisplayOperationButton() ?
          <AuthButton
            name={"登録"}
            size={"large"}
            shape={"round"}
            onClick={addClicked}
          />
          : <></>
        }
      </FooterButtonArea>
    )
  }

  return (
    <Layout>
      <Header />
      <Content>
        <FunctionTitle title={props.title} />
        {
          dataList.some((data: Model.QualificationHolderDataRow) => {
            return data.ccusErrorFlag === CONSTANTS.CCUS_ERROR_FLAG.ON;
          }) ?
          <Alert
            message={
              <>
                <b>{messagesUtils.getMessage("ERROR_GET_CCUS_INFO_TITLE")}</b>
                <br />{messagesUtils.getMessage("ERROR_GET_CCUS_INFO_TEXT_PRIME")}
              </>
            }
            type='warning'
            showIcon
            closable
            style={{
              width: "fit-content"
              , marginTop: "40px"
              , marginBottom :"15px"
              , boxShadow: "0 4px 4px rgba(0,0,0,20%)"
              , textAlign: "left"
            }}
          />
          : <></>
        }
        <QualificationCriteria />
        <CommonMessage searchNoDataName="独自資格保有者" />
        <BelongCompany />
        <QualificationTable />
      </Content>
      <ButtonArea />
      <Footer />
    </Layout >
  );
}

